function fejoPartitionProduct(source) {
  const doc = source.ownerDocument;
  const keys = ['description', 'specifications', 'care', 'shipping'];
  const panels = Object.fromEntries(keys.map(key => [key, doc.createElement('div')]));
  const benefits = [];
  const text = node => node.textContent.replace(/\s+/g, ' ').trim();
  const clean = value => value.replace(/^[\s\d.✔✓✅•📏🧼🌿💚✨]+/u, '').toLowerCase().trim();
  const headingKind = value => {
    const s = clean(value);
    if (/^(wasadvies|wasinstructies|wassen|onderhoud|verzorging|reiniging|schoonmaken|care\b|washing\b)/.test(s)) return 'care';
    if (/^(verzending|levering|levertijd|bezorging|retour|shipping\b|delivery\b)/.test(s)) return 'shipping';
    if (/^(specificaties|productspecificaties|technische (details|gegevens|specificaties)|productdetails|productgegevens|details\s*:|kenmerken\s*:|materiaal\s*:|afmetingen\s*:|inhoud\s*:|samenstelling\s*:|eigenschappen\s*:)/.test(s)) return 'specifications';
    if (/^(waarom\b|voordelen\b|pluspunten\b|de voordelen\b|belangrijkste voordelen\b|dit maakt\b)/.test(s)) return 'benefits';
    return null;
  };
  const fact = value => /^(leeftijd|adviesleeftijd|geschikt (vanaf|voor kinderen)|afmeting(?:en)?|maat|maten|lengte|breedte|hoogte|diameter|gewicht|materiaal|samenstelling|inhoud|aantal|kleur|kleuren|merk|garantie|certificering(?:en)?|veiligheidsnorm(?:en)?|ean|isbn|tog|batterij(?:en)?|voeding|capaciteit|set|foam|cover|afwerking)\s*[:–-]/i.test(clean(value));
  const careLine = value => /^(wasadvies|wasinstructies|wassen op|handwas|machinewas|niet (wassen|drogen|in de droger|bleken)|droog\w*\s*:|reinig\w*\s*:)/i.test(clean(value));
  const shippingLine = value => /^(?:let op\s*:\s*)?(levertijd|levertermijn|verzendtijd|bezorgtijd|verzending|retouradres)(?:\s*[:–-]|\s+is\b|\s+bedraagt\b)/i.test(clean(value));
  const highlight = node => {
    const value = text(node).replace(/^[✔✓✅•]\s*/u, '').trim();
    if (value.length >= 8 && value.length <= 180 && !fact(value) && !shippingLine(value) && !/^(let op|waarschuwing|niet geschikt|alleen onder toezicht)/i.test(value) && !benefits.includes(value)) benefits.push(value);
  };
  let context = 'description';
  function append(node, preferred) {
    const value = text(node);
    if (!value && !node.querySelector?.('img,video,iframe,table')) {
      if (node.nodeType === 3 && node.textContent.trim()) panels.description.append(node);
      return;
    }
    let bucket = preferred === 'benefits' ? 'description' : preferred;
    if (careLine(value)) bucket = 'care';
    else if (shippingLine(value)) bucket = 'shipping';
    else if (fact(value)) bucket = 'specifications';
    panels[bucket || 'description'].append(node);
  }
  function visit(node) {
    if (node.nodeType !== 1) {
      if (node.textContent.trim()) { const p = doc.createElement('p'); p.append(node); append(p, context); }
      return;
    }
    if (['DIV','ARTICLE','SECTION','MAIN'].includes(node.tagName) && !node.querySelector('table,iframe,video')) {
      Array.from(node.childNodes).forEach(visit);
      return;
    }
    if (['UL','OL'].includes(node.tagName)) {
      const items = Array.from(node.children).filter(item => item.tagName === 'LI');
      if (!items.length) { Array.from(node.childNodes).forEach(visit); return; }
      if (items.length === 1 && items[0].querySelector('ul,ol') && items[0].querySelector('p,h2,h3,h4')) {
        Array.from(items[0].childNodes).forEach(visit);
        return;
      }
      let list = null, bucket = null;
      items.forEach(item => {
        const value = text(item);
        const next = careLine(value) ? 'care' : shippingLine(value) ? 'shipping' : fact(value) ? 'specifications' : context === 'benefits' ? 'description' : context;
        if (context === 'benefits' && next === 'description') highlight(item);
        if (next !== bucket) { list = node.cloneNode(false); panels[next].append(list); bucket = next; }
        list.append(item);
      });
      Array.from(node.childNodes).filter(child => child.nodeType === 3 && child.textContent.trim()).forEach(visit);
      Array.from(node.children).filter(child => child.tagName !== 'LI').forEach(visit);
      return;
    }
    const value = text(node);
    const allBold = node.tagName === 'P' && value.length < 120 && node.querySelector('strong,b') && text(node.querySelector('strong,b')) === value;
    const isHeading = /^H[1-6]$/.test(node.tagName) || allBold;
    if (isHeading) {
      context = headingKind(value) || 'description';
      append(node, context);
      return;
    }
    if (node.tagName === 'P' && node.querySelector('br')) {
      const lines = node.innerHTML.split(/<br\b[^>]*>/i);
      const lineNodes = lines.map(html => { const p = doc.createElement('p'); p.innerHTML = html; return p; });
      if (lineNodes.length > 1 && lineNodes.every(p => /^(?:✔|✓|✅|•)/u.test(text(p)) || fact(text(p)) || careLine(text(p)))) {
        lineNodes.forEach(p => { if (/^(?:✔|✓|✅|•)/u.test(text(p))) highlight(p); append(p, context); });
        return;
      }
    }
    append(node, context);
  }
  Array.from(source.childNodes).forEach(visit);
  if (!benefits.length) {
    Array.from(panels.description.querySelectorAll('li')).filter(li => !li.querySelector('ul,ol,p')).forEach(li => {
      if (/zacht|comfort|ademend|stimuleert|motoriek|fantasie|creatief|duurzaam|verstelbaar|thermoregulerend|eenvoudig|herbruikbaar|speelplezier/i.test(text(li))) highlight(li);
    });
  }
  if (!benefits.length) {
    Array.from(panels.description.querySelectorAll('p')).forEach(p => {
      if (p.querySelector('br') || p.querySelector('a')) return;
      const sentences = text(p).match(/[^.!?]+(?:[.!?](?=\s|$)|$)/g) || [];
      sentences.forEach(sentence => {
        if (/zacht|comfort|ademend|stimuleert|motoriek|fantasie|creatief|duurzaam|verstelbaar|thermoregulerend|herbruikbaar|speelplezier/i.test(sentence)) {
          const span = doc.createElement('span'); span.textContent = sentence.trim(); highlight(span);
        }
      });
    });
  }
  return { panels, benefits: benefits.slice(0, 3) };
}

if (!customElements.get('fejo-product-details')) {
  customElements.define('fejo-product-details', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready) return;
      const source = this.querySelector('[data-fejo-description]');
      if (!source) return;
      const working = source.cloneNode(true);
      const result = fejoPartitionProduct(working);
      ['description', 'specifications', 'care', 'shipping'].forEach(key => {
        const target = this.querySelector('[data-fejo-panel="' + key + '"]');
        if (!target) return;
        if (key === 'description') target.replaceChildren(...result.panels[key].childNodes);
        else target.prepend(...result.panels[key].childNodes);
        const details = target.closest('details');
        details.hidden = !target.textContent.trim() && !target.querySelector('img,table,video,iframe');
      });
      const highlights = this.closest('.product-info')?.querySelector('[data-fejo-highlights]');
      if (highlights && result.benefits.length) {
        const list = this.ownerDocument.createElement('ul');
        result.benefits.forEach(value => { const li = this.ownerDocument.createElement('li'); li.textContent = value; list.append(li); });
        highlights.replaceChildren(list);
        highlights.hidden = false;
      }
      this.dataset.ready = 'true';
    }
  });
}


if (!customElements.get('fejo-product-benefits')) {
  customElements.define('fejo-product-benefits', class extends HTMLElement {
    connectedCallback() {
      const template = this.querySelector('template');
      if (!template) return;
      const source = this.ownerDocument.createElement('div');
      source.append(template.content.cloneNode(true));
      const result = fejoPartitionProduct(source);
      const fallback = [...result.panels.description.querySelectorAll('li'), ...result.panels.specifications.querySelectorAll('li')].filter(item => !item.querySelector('li'))
        .map(item => item.textContent.replace(/\s+/g, ' ').replace(/^[✔✓✅•]\s*/u, '').trim())
        .filter(value => value.length >= 8 && value.length <= 180 && !/^(prijs|let op|waarschuwing|niet geschikt|alleen onder toezicht|levertijd|verzending|retour)/i.test(value));
      const values = [...new Set([...result.benefits, ...fallback])].slice(0, 3);
      if (!values.length) return;
      const list = this.ownerDocument.createElement('ul');
      list.className = 'fejo-trial-benefits';
      list.setAttribute('role', 'list');
      for (const value of values) {
        const item = this.ownerDocument.createElement('li');
        item.textContent = value;
        list.append(item);
      }
      this.replaceChildren(list);
      this.hidden = false;
    }
  });
}

if (!customElements.get('fejo-delivery-note')) {
  customElements.define('fejo-delivery-note', class extends HTMLElement {
    connectedCallback() {
      const template = this.querySelector('template');
      if (!template) return;
      const lines = Array.from(template.content.querySelectorAll('p,li')).filter(item => !item.querySelector('p,li'))
        .map(item => item.textContent.replace(/\s+/g, ' ').trim())
        .filter(value => /levertijd|levertermijn|productietijd|vooruitbestelling|pre[ -]?order|afwijkende verzend/i.test(value))
        .map(value => {
          if (value.length <= 360) return value;
          const sentences = value.match(/[^.!?]+(?:[.!?](?=\s|$)|$)/g) || [];
          const short = sentences.slice(0, 2).join('').trim();
          return short.length <= 360 ? short : '';
        }).filter(Boolean);
      const unique = [...new Set(lines)].slice(0, 2);
      if (!unique.length) return;
      const paragraphs = unique.map(value => {
        const paragraph = this.ownerDocument.createElement('p');
        paragraph.textContent = value;
        return paragraph;
      });
      this.replaceChildren(...paragraphs);
      this.hidden = false;
    }
  });
}
